import { BrowserRouter, Routes, Route } from "react-router-dom";

import Home from "./pages/Home";
import ManholeCoverProducts from "./pages/ManholeCoverProducts";
import PipesFittingsProducts from "./pages/PipeFittingsProducts";
import ValvesFastenersProducts from "./pages/ValvesFasternersProducts";
import InsulatorsProducts from "./pages/InsulatorsProducts";

function App() {
  return (
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/products/manhole-covers" element={<ManholeCoverProducts />} />
        <Route path="/products/pipes-fittings" element={<PipesFittingsProducts />} />
        <Route path="/products/valves-fasteners" element={<ValvesFastenersProducts />} />
        <Route path="/products/insulators" element={<InsulatorsProducts />} />
      </Routes>
  );
}

export default App;
